<script setup>
import { CdrText } from '@rei/cedar';
import { useDepartureStore } from '../../stores/day-cancellation/departure';

const departure = useDepartureStore();
</script>

<template>
  <div class="departure-info">
    <CdrText
      class="departure-info__name"
      tag="h4"
      data-ui="departure-info-name"
    >
      {{ departure.name }}
    </CdrText>
    <CdrText
      class="departure-info__info"
      data-ui="departure-info-start-date"
    >
      {{ departure.startDate }}
    </CdrText>
    <CdrText
      class="departure-info__info"
      data-ui="departure-info-start-time"
    >
      {{ departure.startTime }}
    </CdrText>
    <CdrText
      class="departure-info__info"
      data-ui="departure-info-location"
    >
      {{ departure.location }}
    </CdrText>
  </div>
</template>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.departure-info {
  display: flex;
  flex-direction: column;

  &__name {
    @include cdr-text-body-strong-300;
  }

  &__info {
    @include cdr-text-body-300;
  }
}
</style>
